
const Loader = () => {

    //console.log('Waiting...')

    function svgLogo() {

        //setInterval(() => { console.log('-') }, 200)

        return (
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
                <g>
                    <path className="path" strokeWidth="2px" stroke="#FFF" fill="none" d="M75.6,46.6c-0.8-1.1-1.7-2.2-2.8-3.3c-2-2-4-3.5-5.8-4.7c-0.4-0.2-0.8-0.5-1.2-0.7C56,32,49.5,21.3,49.5,9.1
		c0-2.4,0.2-4.7,0.7-6.9C39.7,7.9,32.6,19,32.6,31.8c0,2.4,0.3,4.8,0.8,7.1c0.6,2.7,1.5,5.2,2.6,7.6c-2.2,0.9-5.8,1.1-8.3-3.1
		c-0.2,0.2-0.4,0.4-0.6,0.6c-5.4,5.7-8.7,13.4-8.7,21.8c0,17.6,14.3,31.8,31.8,31.8c8.6,0,16.4-3.4,22.2-9c0.1-0.1,0.2-0.2,0.3-0.3
		c-7.5-7.5,0-15,0-15s4-3.3,5.9-10.3C80,58.5,80,52.6,75.6,46.6z"/>
                </g>
            </svg>
        )
    }
    return (
        <div className="loader">
            <div className="loader__bar">
                <div className="loader__logo">
                    {svgLogo()}
                </div>
            </div>
        </div>
    )
};
export default Loader;